import { fundTransferConstants } from "../_constants";

const INITIAL_FUND_TRANSFER_PAYMENTS_DATA_STATE = {
  currencyData: {},
  readyToPay: false,
  payFromList: [],
  purposeCodeLimitList: [],
  tranferLimitsList: [],
  purposeCodeList: [],
  payToList: [],
  ownFormData: {},
  initiateData: {},
  otpData: {},
  payData: {},
  bankList: [],
  bankAccountDetails: {},
  fundTransferOtpTimer: 0,
};

export function fundTransferReducer(
  state = INITIAL_FUND_TRANSFER_PAYMENTS_DATA_STATE,
  action,
) {
  switch (action.type) {
    case fundTransferConstants.FUND_TRANSFER_PAY_FROM_LIST_REQUEST:
      return {
        ...state,
        payFromList: [],
        readyToPay: false,
        otpData: {},
        tranferLimitsList: [],
        purposeCodeLimitList: [],
        purposeCodeList: [],
        fundTransferOtpTimer: 0,
        bankAccountDetails: {},
      };

    case fundTransferConstants.FUND_TRANSFER_PAY_FROM_LIST_COMPLETE:
      return {
        ...state,
        readyToPay: true,
        payFromList: action.payload?.data?.accountList,
        tranferLimitsList: action.payload?.data?.tranferLimitsList,
        purposeCodeLimitList: action.payload?.data?.purposeCodeLimitsList,
        purposeCodeList: action.payload?.data?.purposeCodeList,
      };

    case fundTransferConstants.FUND_TRANSFER_PAY_FROM_LIST_ERROR:
      return {
        ...state,
        readyToPay: true,
        payFromList: [],
        tranferLimitsList: [],
        purposeCodeLimitList: [],
        purposeCodeList: [],
      };

    case fundTransferConstants.FUND_TRANSFER_PAY_TO_LIST_REQUEST:
      return {
        ...state,
        payToList: [],
      };

    case fundTransferConstants.FUND_TRANSFER_PAY_TO_LIST_COMPLETE:
      return {
        ...state,
        payToList: action.payload?.data?.accountList,
      };

    case fundTransferConstants.FUND_TRANSFER_PAY_TO_LIST_ERROR:
      return {
        ...state,
        payToList: [],
      };

    case fundTransferConstants.FUND_TRANSFER_OWN_INITIALIZE_REQUEST:
      return {
        ...state,
        ownFormData: action.payload?.restoreData,
        initiateData: {},
      };

    case fundTransferConstants.SET_FUND_TRANSFER_OWN_FORM_DATA:
      return {
        ...state,
        ownFormData: action.payload,
      };
    case fundTransferConstants.FUND_TRANSFER_OWN_INITIALIZE_COMPLETE:
      return {
        ...state,
        initiateData: action.payload.data,
        otpData: {},
        fundTransferOtpTimer: 0,
      };

    case fundTransferConstants.FUND_TRANSFER_OWN_INITIALIZE_ERROR:
      return {
        ...state,
        initiateData: {},
      };

    case fundTransferConstants.CLEAR_FUND_TRANSFER_FORMS:
      return {
        ...state,
        payFromList: [],
        ownFormData: {},
        initiateData: {},
        currencyData: {},
        payToList: [],
        otpData: {},
        payData: {},
        fundTransferOtpTimer: 0,
      };

    case fundTransferConstants.CLEAR_FUND_TRANSFER_INTIALIZATION:
      return {
        ...state,
        initiateData: {},
        otpData: {},
        fundTransferOtpTimer: 0,
      };

    case fundTransferConstants.FAVOURITE_CLEAR_FUND_TRANSFER_INTIALIZATION:
      return {
        ...state,
        initiateData: {},
        otpData: {},
        fundTransferOtpTimer: 0,
        payData: {},
      };

    case fundTransferConstants.FUND_TRANSFER_PAY_TO_LIST_COMPLETE:
      return {
        ...state,
        payToList: action.payload?.data?.accountList,
      };

    case fundTransferConstants.FUND_TRANSFER_CURRENCY_CONVERTION_REQUEST:
      return {
        ...state,
        currencyData: {},
      };

    case fundTransferConstants.FUND_TRANSFER_CURRENCY_CONVERTION_COMPLETE:
      return {
        ...state,
        currencyData: action.payload?.data,
      };

    case fundTransferConstants.FUND_TRANSFER_CURRENCY_CONVERTION_ERROR:
      return {
        ...state,
        currencyData: [],
      };

    case fundTransferConstants.FUND_TRANSFER_OTP_COMPLETE:
      return {
        ...state,
        otpData: action.payload?.data,
        fundTransferOtpTimer: action.payload?.data?.otpTimerTimePeriod,
      };

    case fundTransferConstants.FUND_TRANSFER_OTP_ERROR:
      return {
        ...state,
        otpData: {},
        fundTransferOtpTimer:
          action?.payload?.response?.errorDetails?.remainingTime,
      };

    case fundTransferConstants.FUND_TRANSFER_PROCEED_REQUEST:
      return {
        ...state,
        payData: {},
      };

    case fundTransferConstants.FUND_TRANSFER_PROCEED_COMPLETE:
      return {
        ...state,
        payData: action.payload?.data,
      };

    case fundTransferConstants.FUND_TRANSFER_PROCEED_ERROR:
      return {
        ...state,
        payData: action.payload.response.errorResponse,
      };

    case fundTransferConstants.FUND_TRANSFER_BANK_LIST_REQUEST:
      return {
        ...state,
        bankList: [],
      };

    case fundTransferConstants.FUND_TRANSFER_BANK_LIST_COMPLETE:
      return {
        ...state,
        bankList: action.payload?.data?.bankList,
      };

    case fundTransferConstants.FUND_TRANSFER_BANK_LIST_ERROR:
      return {
        ...state,
        bankList: [],
      };

    case fundTransferConstants.FUND_TRANSFER_VALIDATE_ACCOUNT_DETAIL_REQUEST:
      return {
        ...state,
        bankAccountDetails: {},
      };

    case fundTransferConstants.FUND_TRANSFER_VALIDATE_ACCOUNT_DETAIL_COMPLETE:
      return {
        ...state,
        bankAccountDetails: action.payload?.data,
      };

    case fundTransferConstants.FUND_TRANSFER_VALIDATE_ACCOUNT_DETAIL_ERROR:
      return {
        ...state,
        bankAccountDetails: {},
      };
  }

  return state;
}
